<template>
  <div>
    <div v-if="layoutData.enable_na || layoutData.label != null" class="row">
      <div class="col-md-5 col-sm-5 col-xs-5 text-right" style="font-weight: bold; padding-right: 0; padding-left: 0; margin-top:5px; text-decoration: underline">{{layoutData.label}}</div>
      <div class="col-md-7 col-sm-7 col-xs-7 d-flex" :class="layoutData.none_allowed === true ? 'text-left' : 'text-right'" :style="{'justify-content': 'space-between'}">
        <button v-if="layoutData.none_allowed === true && layoutData.valueGroups.length == 0" class="btn green-jungle" @click="addClick"><i class="fa fa-plus"></i></button>
        <button v-if="layoutData.enable_na" class="btn" :class="layoutData.na_value ? 'btn-danger' : 'btn-default'" @click="naToggle">N/A</button>
      </div>
    </div>
    <div v-for="(valueGroup, index2) in layoutData.valueGroups">
      <timesheet-field 
        v-for="(field, index) in enabledFields" :key="index" 
        :layout="field" 
        :value="valueGroup[field.name]" 
        :errors="layoutData.errors[index2] == undefined || layoutData.errors[index2][field.name] == undefined ? [] : layoutData.errors[index2][field.name]"
        :index="index2" 
        :showAddButton="index==0 && index2==0" 
        :showRemoveButton="index==0 && index2!=0 || index==0 && layoutData.none_allowed === true" 
        @change="onActivityChange"
        @addClick="addClick"
        @removeClick="removeClick"
      />
    </div>
  </div>
</template>

<script>
  import TimesheetField from '../field/TimesheetField.vue';
  import TimesheetFieldset from '../TimesheetFieldset.vue'
  export default {
    components: { 
      TimesheetFieldset: () => import('../TimesheetFieldset.vue'),
      TimesheetField 
    },
    name: "timesheet-group-material",
    props: {
      layout: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        layoutData: this.layout
      }
    },
    computed: {
      enabledFields() {
        return this.layoutData.fields.filter(e => e.enabled !== false); 
      },
    },
    created () {
      if(this.layoutData.errors == null) {
        this.$set(this.layoutData, "errors", []);
      }

      if(this.layoutData.valueGroups == undefined) {
        if(this.layoutData.none_allowed === true) {
          this.$set(this.layoutData, 'valueGroups', []);
        } else {
          this.$set(this.layoutData, 'valueGroups', [{}]);
        }
      }
    },
    methods: {
      addClick(e,l,i) {
        this.layoutData.valueGroups.push({});
        this.layoutData.errors.push({});
        this.onChange(e, l, this.valueGroups, i)
      },
      removeClick(e,l,i) {
        this.layoutData.valueGroups.splice(i,1);
        this.layoutData.errors.splice(i,1);
        this.onChange(e, l, this.valueGroups, i)
      },
      onChange(e,l,v,i) {
        if(l != undefined && this.layoutData.errors[i] != undefined) {
          this.$set(this.layoutData.errors[i], l.name, l.errors);
        }
        this.$emit("change", e, l, v, i)
      },
      onActivityChange(e,l,v,i) {
        this.layoutData.valueGroups[i][l.name] = v;
        this.onChange(e,l,v,i);
      },
      naToggle(e) {
        this.layoutData.na_value = !this.layoutData.na_value;
        if(this.layoutData.na_value) {
          this.$set(this.layoutData, "errors", []);
        }
        this.onChange(e, this.layoutData, this.valueGroups, -1)
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>